module.exports = __webpack_public_path__ + "static/logo-wide-ac4aecc81770161d282c8108e5d89cb5.jpg";